export default {
    DEFAULT_LANG: 'pl',
    GLOBAL_LANG: 'en',
    EN: 'EN',
    PL: 'PL',
    FR: 'FR',
    DE: 'DE'
}